import React from "react";

import { useEffect, useRef } from "react";

const Dialog = ({ title = "Message", isModal = true, isOpen = false, onCancel, children, className, style=null, footer=null }) => {
  const dialogRef = useRef(null);
  const lastActiveElement = useRef(null);

  // This will allow a non-modal dialog to be dismissed using the <Escape> key
  useEffect(() => {
    if (!isModal && isOpen) {
      const keydownHandler = event => {
        if (event.key === "Escape") {
          onCancel();
        }
      };

      document.addEventListener("keydown", keydownHandler);

      return () => {
        document.removeEventListener("keydown", keydownHandler);
      };
    }

    return undefined;
  }, [onCancel, isModal, isOpen]);

  useEffect(() => {
    if (isOpen) {
      lastActiveElement.current = document.activeElement;

      if (isModal) {        
        dialogRef.current.showModal();        
      } else {
        dialogRef.current.show();
      }
    } else {
      dialogRef.current.close();

      // set focus back to element that had the focus before the dialog was opened
      lastActiveElement.current?.focus({ focusVisible: true });
    }

    return undefined;
  }, [isOpen, isModal]);

  // onCancel is called when you press the esc key - done automatically by the dialog if it is modal
  return (
    <dialog style={style} className={"p-dialog dialog " + (className ? className : "")} ref={dialogRef}>
      <header className="p-dialog-header dialog-header">
        {title}
      </header>
      <div className={"p-dialog-content"}>
      {children}
      </div>
      {footer && (<div className={"p-dialog-footer"}>
        {footer}
      </div>)}
    </dialog>
  );
};

export default Dialog;
